import useSWR from 'swr';
import { useForm } from 'react-hook-form';
import {
 Image,
 Button,
 Input,
 Stack,
 Popover,
 PopoverTrigger,
 PopoverContent,
 PopoverHeader,
 PopoverBody,
 Text,
 Box,
 Flex,
 useDisclosure,
 PopoverFooter,
 useToast,
} from '@chakra-ui/react';
import { chat } from '../../assets/new-images/icons';
import baseService from '../../services/base';
import { fetchData } from '../../services/fetch';

export default function FeedbackChatReviewerPopover({
 response,
 idSurvey,
 currentAdminRole,
 question,
 isSingle = true,
}) {
 const toast = useToast();
 const { isOpen, onToggle, onClose } = useDisclosure();
 const {
  handleSubmit,
  register,
  getValues,
  resetField,
  formState: { isValid, isSubmitting },
 } = useForm();

 const getFeedbackUrl = () => {
  let url = `feedback/question?user=${response?.id_user}&company=${response?.company?.id_company}&type=admin_company&question=${question?.id_question}`;
  if (question?.id_theme) {
   url += `&id_theme=${question?.id_theme}`;
  }
  return url;
 };

 const {
  data: feedbackData,
  isLoading,
  mutate,
 } = useSWR(isOpen ? getFeedbackUrl() : null, fetchData);

 async function onSubmit() {
  try {
   const values = {
    id_role: currentAdminRole,
    id_question: question?.id_question,
    id_survey: idSurvey,
    id_user: response?.id_user,
    id_company: response?.company?.id_company,
    type: 'admin_company',
    text: getValues('text'),
   };
   await baseService.post('feedback', values);
   toast({
    title: 'Mensagem enviada com sucesso',
    status: 'success',
   });
   handleClose();
   mutate();
  } catch (err) {}
 }

 async function removeFeedback(id) {
  try {
   await baseService.delete(`feedback/${id}`);
   toast({
    title: 'Feedback removido com sucesso',
    status: 'success',
    containerStyle: {
     width: 'fit-content',
     maxWidth: '100%',
     bg: '#2F2F2F',
     fontWeight: 400,
     whiteSpace: 'nowrap',
    },
   });
   handleClose();
   mutate();
  } catch (err) {
   toast({
    title: 'Erro ao excluir',
    description: 'Não foi possível excluir sua mensagem, contate o suporte',
    status: 'error',
   });
  }
 }

 const handleClose = () => {
  resetField('text');
  onClose();
 };

 return (
  <Flex
   height='44px'
   align='center'
   gap='14px'
   pos='absolute'
   top={['12px', '6']}
   right={isSingle ? '6' : '132px'}
  >
   <Popover
    trigger='click'
    isOpen={isOpen && !isLoading}
    onClose={handleClose}
    placement='bottom-end'
    isLazy
    strategy='fixed'
   >
    <PopoverTrigger>
     <Button
     isDisabled={!question?.user_responses}
      onClick={onToggle}
      bg='#F5F5FB'
      borderRadius='41.7px'
      w='fit-content'
      height={['32px', '44px']}
      p='0 12px'
      alignItems={'center'}
      justifyContent={'center'}
      _active={{
       bg: '#F5F5FB',
      }}
      _disabled={{
        bg: '#F5F5FB',
        cursor: 'not-allowed'
      }}
     >
      <Image src={chat} alt='Feedback chat' height={['21px', 'auto']} />
     </Button>
    </PopoverTrigger>

    <PopoverContent
     w={'450px'}
     borderRadius='8px'
     boxShadow='0px 0px 100px 100vw rgba(0, 0, 0, 0.20)'
     textAlign='left'
     overflow='hidden'
     minH='192px'
     maxH='450px'
    >
     <PopoverHeader
      bg='gray.100'
      h='40px'
      fontWeight={700}
      border='0'
      fontSize='sm'
      lineHeight='16.44px'
      p='12px'
     >
      Feedback interno
     </PopoverHeader>

     <PopoverBody bg='white' p='16px 12px' maxH='352px' overflowY='scroll'>
      <PopoverBody bg='white' p='16px 12px' maxH='352px' overflowY='scroll'>
       {feedbackData ? (
        <>
         {feedbackData?.map((feedback) => (
          <Stack key={feedback?.id_feedback} spacing='8px' my='12px'>
           <Flex
            bg='rgba(0, 178, 239, 0.1)'
            p='12px'
            borderRadius='20px 20px 20px 0px'
            flexDir='column'
           >
            <Text
             fontSize='sm'
             color='#00B2EF'
             whiteSpace='normal'
             lineHeight='20px'
             letterSpacing='0.1px'
            >
             {feedback?.text}
            </Text>
           </Flex>

           <Button
            variant='ghost'
            fontSize='12px'
            h='22px'
            justifyContent='end'
            p={0}
            color='#EA582B'
            onClick={() => removeFeedback(feedback?.id_feedback)}
           >
            Remover feedback
           </Button>
          </Stack>
         ))}
         {!feedbackData?.length && !isLoading && (
          <Box bg='#F5F5FB' p='12px'>
           <Text
            fontSize='sm'
            color='#5C6066'
            whiteSpace='normal'
            lineHeight='20px'
            letterSpacing='0.1px'
            textAlign={'center'}
           >
            Envie agora um feedback sobre a resposta.
           </Text>
          </Box>
         )}
        </>
       ) : (
        <Box bg='#F5F5FB' p='12px'>
         <Text
          fontSize='sm'
          color='#5C6066'
          whiteSpace='normal'
          lineHeight='20px'
          letterSpacing='0.1px'
          textAlign={'center'}
         >
          Aqui você pode enviar feedbacks sobre a resposta.
         </Text>
        </Box>
       )}
      </PopoverBody>
     </PopoverBody>

     <PopoverFooter p={'8px 12px'} bg='#F5F5FB' h='72px' border='none'>
      <Flex h='full' align='center' gap={'16px'}>
       <Input
        w={'100%'}
        h='40px'
        bg='white'
        fontSize='sm'
        borderRadius='10px'
        border='1px solid #E4E4E4'
        placeholder='Digite sua mensagem'
        overflow={'scroll'}
        _placeholderShown={{
         fontWeight: 400,
         color: '#828282',
        }}
        {...register('text', { required: true })}
       />
       <Button
        type='submit'
        variant='primary'
        w={'106px'}
        minW='106px'
        h='56px'
        fontSize='sm'
        isDisabled={!isValid}
        isLoading={isSubmitting}
        onClick={handleSubmit(onSubmit)}
       >
        Enviar
       </Button>
      </Flex>
     </PopoverFooter>
    </PopoverContent>
   </Popover>
  </Flex>
 );
}
